export const EarthenHuesLight = () => ({
	backgroundDefault: '#F9F1D5',
	backgroundPrimary: '#FFFFFF',
	backgroundPrimary60: '#F7F1E0',
	backgroundSecondary: '#F9E9B2',
});
